<div class="viewdata-container">
  <div *ngFor="let group of applicationData?.dataGroup; trackBy: trackByGroup">
    <ng-content
      *ngTemplateOutlet="
        accordion;
        context: {
          headerTitle: group.groupName,
          groupDescription: group.groupDescription,
          groupCode: group.groupCode,
          dataFields: group.dataFields,
          splitAfter: group.splitAfter
        }
      "
    ></ng-content>
  </div>
</div>
<ng-template
  #accordion
  let-headerTitle="headerTitle"
  let-groupDescription="groupDescription"
  let-dataFields="dataFields"
  let-groupCode="groupCode"
  let-splitAfter="splitAfter"
>
  <goab-accordion
    class="accordion-container"
    [heading]="headerTitle"
    headingSize="small"
    (_change)="toggleAccordion(groupCode, $event)"
    [open]="isExpanded(groupCode)"
  >
    <ng-container
      *ngIf="
        (groupCode === applicantProfileStep && applicantProfile?.verified) ||
        (groupCode === signerProfileStep && signerProfile?.verified)
      "
      [ngTemplateOutlet]="displayProfile"
      [ngTemplateOutletContext]="{
        profile: groupCode === applicantProfileStep ? applicantProfile : signerProfile
      }"
    ></ng-container>

    <div class="detail-grouping width-100 accordion-inner-container">
      <div class="intro-text" *ngIf="groupDescription" [innerHtml]="groupDescription"></div>

      <!-- First Group (Before Split) - Shows all if splitAfter is missing or 0 -->
      <div class="flex-column">
        <div class="groupItem">
          <ng-container *ngIf="dataFields?.length && groupFieldsBySubHeader(dataFields) as grouped">
            <ng-container *ngFor="let group of grouped; let i = index; trackBy: trackByIndex">
              <ng-container *ngIf="group.subHeader as subHeader; else noSubHeaderFields">
                <div class="subheader">
                  <h3>{{ subHeader }}</h3>
                  <ng-container *ngFor="let field of group.fields; trackBy: trackByField">
                    <ng-container
                      [ngTemplateOutlet]="displayField"
                      [ngTemplateOutletContext]="{
                        field: field,
                        dataFields: dataFields,
                        index: i,
                        groupCode: groupCode
                      }"
                    ></ng-container>
                  </ng-container>
                </div>
              </ng-container>

              <ng-template #noSubHeaderFields>
                <ng-container
                  *ngFor="
                    let field of fieldsToDisplay(dataFields) | slice: 0:splitAfter || dataFields.length;
                    let i = index;
                    trackBy: trackByField
                  "
                >
                  <ng-container
                    [ngTemplateOutlet]="displayField"
                    [ngTemplateOutletContext]="{
                      field: field,
                      dataFields: dataFields,
                      index: i,
                      groupCode: groupCode
                    }"
                  ></ng-container>
                </ng-container>
              </ng-template>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- Second Group (After Split) - Only displays if splitAfter is valid -->
      <div class="flex-column leftBorder" *ngIf="splitAfter && splitAfter < dataFields.length">
        <div class="groupItem">
          <ng-container *ngFor="let field of dataFields | slice: splitAfter; let i = index; trackBy: trackByField">
            <ng-container
              [ngTemplateOutlet]="displayField"
              [ngTemplateOutletContext]="{
                field: field,
                dataFields: dataFields,
                index: i,
                groupCode: groupCode
              }"
            ></ng-container>
          </ng-container>
        </div>
      </div>

      <!--render document list at the end of the section using Documents display mode-->
      <ng-container
        [ngTemplateOutlet]="documentListCollectionTemplate"
        [ngTemplateOutletContext]="{
          dataFields: dataFields,
          index: -1,
          displayMode: displayMode.Documents,
          groupCode: groupCode
        }"
      ></ng-container>
    </div>
  </goab-accordion>
</ng-template>

<!-- Templates for different display modes -->

<!--Normal display mode: default key value pairing-->
<ng-template #displayModeNormal let-field="field">
  <common-displayfield-control [attr.data-cy]="field.snapshotValue.label" [label]="field.snapshotValue.label">
    {{ field.snapshotValue.value || '-' }}
  </common-displayfield-control>
</ng-template>

<!--Grid display mode: for income/assets column header and values-->
<ng-template #displayModeGrid let-field="field">
  <div class="grid grid-mode">
    <div class="table">
      <div class="header">
        <div
          *ngFor="let header of field.snapshotValue?.headerCollection ?? field?.headerCollection; trackBy: trackByIndex"
          class="cell"
        >
          <span class="header-label" [title]="header">{{ header }}</span>
        </div>
      </div>
      <div class="body">
        <div
          class="row"
          *ngFor="let row of field.snapshotValue?.valueCollection ?? field?.valueCollection; trackBy: trackByIndex"
        >
          <div
            class="column"
            *ngFor="let column of row.valueCollection; let i = index; trackBy: trackByIndex"
            class="cell"
          >
            <div class="column-header">
              {{ (field.snapshotValue?.headerCollection ?? field?.headerCollection)[i] }}
            </div>
            <div>{{ column.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--Grid display mode: for income/assets column header and values for only 1 column-->
<ng-template #displayModeGridTwoColumn let-field="field">
  <div class="grid grid-mode-two-column">
    <div class="table">
      <div class="header" [class]="field.snapshotValue?.headerCollection?.length == 2 ? 'one-column' : 'multi-column'">
        <div
          *ngFor="
            let header of field.snapshotValue?.headerCollection ?? field?.headerCollection;
            let x = index;
            trackBy: trackByIndex
          "
          class="cell"
          [class]="!utils.hasValue(field.snapshotValue?.headerCollection[x]) ? 'empty-column' : ''"
        >
          <span class="header-label" [title]="header">{{ header }}</span>
        </div>
      </div>
      <div class="body">
        <div
          class="row"
          *ngFor="let row of field.snapshotValue?.valueCollection ?? field?.valueCollection; trackBy: trackByIndex"
        >
          <div class="column cell" *ngFor="let column of row.valueCollection; let i = index; trackBy: trackByIndex">
            <div class="column-header">
              {{ (field.snapshotValue?.headerCollection ?? field?.headerCollection)[i] }}
            </div>
            <div class="column-value">{{ column.value }}</div>
          </div>
          <div class="blank-cell"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--Multi input display mode: for questions with multiple answers or multiple sub questions-->
<!--If value is null or undefined, do not show field. If emptry string then replace with '-'-->
<ng-template #displayModeMultiInput let-field="field">
  <!--do not show if no label and no value. happens if field is just a collection of objects-->
  <!-- <div *ngIf="field?.snapshotValue?.questionHeader">{{ field?.snapshotValue?.questionHeader }}</div> -->
  <div *ngIf="field?.snapshotValue?.questionHeader" [innerHTML]="field?.snapshotValue?.questionHeader"></div>
  <common-displayfield-control
    *ngIf="field?.snapshotValue?.label || field?.snapshotValue?.value"
    [attr.data-cy]="field.snapshotValue.label"
    [label]="field.snapshotValue.label"
  >
    <ng-container *ngIf="field.snapshotValue.value !== null && field.snapshotValue.value !== undefined">{{
      field.snapshotValue.value || '-'
    }}</ng-container>
  </common-displayfield-control>
  <ng-container *ngIf="field.snapshotValue.valueCollection?.length > 0">
    <ng-container
      *ngFor="let itemValue of field.snapshotValue.valueCollection || []; let i = index; trackBy: trackByValueItem"
    >
      <!--indent only if item has a label and parent object has label (sub question)-->
      <div
        [class]="
          (itemValue.label?.length > 0 && field.snapshotValue.label) || itemValue.displayMode != 0
            ? 'displayfield-indent'
            : ''
        "
      >
        <!-- <div class="questionHeader" *ngIf="itemValue?.questionHeader">{{ itemValue?.questionHeader }}</div> -->
        <div class="questionHeader" *ngIf="itemValue?.questionHeader" [innerHTML]="itemValue?.questionHeader"></div>
        <common-displayfield-control
          *ngIf="itemValue.displayMode == 0"
          [label]="itemValue.label"
          [attr.data-cy]="field.fieldReference + '-' + i"
          >{{ itemValue.value || '-' }}
        </common-displayfield-control>
        <ng-container
          *ngIf="itemValue.displayMode != 0"
          [ngTemplateOutlet]="getTemplateForDisplayMode(itemValue.displayMode)"
          [ngTemplateOutletContext]="{ field: itemValue }"
        ></ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<!--Signer stamp template-->
<ng-template #displayProfile let-profile="profile">
  <common-verified-info-display [profileData]="profile"></common-verified-info-display>
</ng-template>

<ng-template
  #documentListCollectionTemplate
  let-dataFields="dataFields"
  let-index="index"
  let-displayMode="displayMode"
  let-groupCode="groupCode"
>
  <ng-container *ngIf="documentListCollection(dataFields, displayMode, index) as docListCollection">
    <ng-container *ngFor="let docList of docListCollection; trackBy: trackByDocumentList">
      <div
        class="document-list"
        *ngIf="docList?.documentList?.documents?.length > 0 || docList?.documentList?.optOut?.length > 0"
      >
        <common-document-snapshot-preview
          [parentId]="_applicationData.applicationId"
          [documentList]="docList?.documentList"
          [showInGroups]="true"
          [categoryLookup]="documentCategoryLookup[groupCode]"
          >{{
            docList?.documentList?.title ?? docList?.label ?? 'Uploaded documents'
          }}</common-document-snapshot-preview
        >
      </div>
      <div
        class="document-list"
        *ngIf="docList?.documentsPersonal?.documents?.length > 0 || docList?.documentsPersonal?.optOut?.length > 0"
      >
        <common-document-snapshot-preview
          [parentId]="_applicationData.applicationId"
          [documentList]="docList?.documentsPersonal"
          [showInGroups]="true"
          [categoryLookup]="documentCategoryLookup[groupCode]"
          [sectionCode]="_"
          >{{
            docList?.documentsPersonal?.title ?? docList?.label ?? 'Uploaded documents'
          }}</common-document-snapshot-preview
        >
      </div>
      <div
        class="document-list"
        *ngIf="docList?.documentsSpouse?.documents?.length > 0 || docList?.documentsSpouse?.optOut?.length > 0"
      >
        <common-document-snapshot-preview
          [parentId]="_applicationData.applicationId"
          [documentList]="docList?.documentsSpouse"
          [showInGroups]="true"
          [categoryLookup]="documentCategoryLookup[groupCode]"
          >{{
            docList?.documentsSpouse?.title ?? docList?.label ?? 'Uploaded documents'
          }}</common-document-snapshot-preview
        >
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #displayModeCallout let-field="field">
  <div class="callout-content">
    <common-callout-content
      [calloutContent]="field.calloutContent"
      calloutWrapperClass="calloutBoxMaxWidth"
    ></common-callout-content>
  </div>
</ng-template>

<ng-template #displayField let-field="field" let-dataFields="dataFields" let-index="index" let-groupCode="groupCode">
  <!--render snapshot content-->
  <div *ngIf="field?.snapshotValue && getTemplateForDisplayMode(field.snapshotValue.displayMode)">
    <ng-container
      [ngTemplateOutlet]="getTemplateForDisplayMode(field.snapshotValue.displayMode)"
      [ngTemplateOutletContext]="{ field: field }"
    ></ng-container>
  </div>

  <!--render callout content-->
  <div *ngIf="field?.calloutContent">
    <ng-container [ngTemplateOutlet]="displayModeCallout" [ngTemplateOutletContext]="{ field: field }"></ng-container>
  </div>

  <!--render document list inline with data using NestedDocuments display mode-->
  <ng-container *ngIf="field?.fieldReference === 'documentList'">
    <ng-container
      [ngTemplateOutlet]="documentListCollectionTemplate"
      [ngTemplateOutletContext]="{
        dataFields: dataFields,
        index: index,
        displayMode: displayMode.NestedDocuments,
        groupCode: groupCode
      }"
    ></ng-container>
  </ng-container>
</ng-template>
